import { Component, OnInit } from '@angular/core';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import { EventService } from '../event.service';
import { Subscription } from 'rxjs';
import { ValidationService } from '../validation.service';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '../storage.service';
import { environment } from 'src/environments/environment';

export interface additionalCharges {
  'cancellation': boolean;
  'extra_delivery': boolean;
  'extra_pickup': boolean;
  'labour': boolean;
  'toll': boolean;
  'LR_charges': boolean;
  'insurance': boolean;
  'non_hometown_halt': boolean;
  'doc': boolean;
  'detentionCustomer': boolean;
  'detentionPlant': boolean;
  'charges_id'?: string;
  'green_tax': boolean;
  'odc_charges': false;
  'rto_fines': false;
}
export interface paymentInfo {
  'bank_details': {
    'account_number': string,
    'branch_code': string,
    'branch_name': string,
    'iba_code': string,
    'name': string
  };
  'tax_details': {
    'GSTIN': string,
    'PAN': string,
    'tax_id_3': string
  };
  'URD': Boolean;
}

export interface invoiceSequence {
  'custom_IINC_enabled': boolean;
  'custom_range': {
    'from': number;
    'to': number;
  };
  'custom_text': string;
}
export interface billSequence {
  'custom_CBIN_enabled': boolean;
  'custom_range': {
    'from': number;
    'to': number;
  };
  'custom_text': string;
}
@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss']
})

export class AccountSettingsComponent implements OnInit {

  additionalCharges: additionalCharges = {
    cancellation: false,
    extra_delivery: false,
    extra_pickup: false,
    labour: false,
    toll: false,
    LR_charges: false,
    insurance: false,
    non_hometown_halt: false,
    doc: false,
    detentionCustomer: false,
    detentionPlant: false,
    green_tax: false,
    odc_charges: false,
    rto_fines: false
  };

  GTAToGTA: boolean = false;
  invoiceDeclaration = false;
  tempGSTIN: any = {
    disabled: false
  };

  invoiceSequence: invoiceSequence = {
    custom_IINC_enabled: true,
    custom_range: {
      from: 0,
      to: 0
    },
    custom_text: ''
  };
  billSequence: billSequence = {
    custom_CBIN_enabled: true,
    custom_range: {
      from: 0,
      to: 0
    },
    custom_text: ''
  };
  billing_address = '';
  country;
  billSequenceDefault: any = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    SIN_Code: '',
    counter: 0,
    version_alphabet: 'A',
    series: ''
  };

  invoiceSequenceDefault: any = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    SIN_Code: '',
    counter: 0,
    version_alphabet: 'A',
    series: ''
  };

  tax_types = [
    { name: 'Forward Charge Mechanism - 12', value: 'FCM12' },
    { name: 'Forward Charge Mechanism - 18', value: 'FCM18' },
    { name: 'Reverse Charge Mechanism', value: 'RCM' }
  ];

  selectedTaxType: any;

  bill_defaultTc = '';
  invoice_defaultTc = '';
  paymentInfo: paymentInfo = {
    bank_details: {
      account_number: '',
      branch_code: '',
      branch_name: '',
      iba_code: '',
      name: ''
    },
    tax_details: {
      GSTIN: '',
      PAN: '',
      tax_id_3: ''
    },
    URD: false
  };

  disable_tax_type = false;
  logo = '';
  lrSeq: any = {
    lr_seq: '',
    custom_CWB_enabled: false
  };

  sac_code = '';
  creditNoteNarration = '';

  enable_sac = false;

  billing_emails;
  carrier_code;
  shippers: any;
  showLoader = false;
  selectedOrg: any;
  post = true;
  carrierId: Subscription;
  constructor(private snackBar: SnackbarService, private http: HttpService, private events: EventService,
    private valid: ValidationService, private translation: TranslateService, private storage: StorageService) {
    this.enable_sac = (environment.country == 'SA'); // enable service code if country == KSA
    this.country = environment.country;
  }

  ngOnInit() {
    this.getConstants();
    this.getShippers();
    const carriers = JSON.parse(this.storage.getFromLocalStorage('carriers'));
    this.carrier_code = carriers[0].short_code;
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {

        const selectedCarrier = carriers.filter((carrier) => {
          if (carrier) {
            return carrier._id === data.carrier_id;
          }
        });
        this.carrier_code = selectedCarrier[0].short_code;
        this.refreshConstants();
        this.getConstants();
        this.getShippers();
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );
  }

  refreshConstants() {
    this.additionalCharges = {
      cancellation: false,
      extra_delivery: false,
      extra_pickup: false,
      labour: false,
      toll: false,
      LR_charges: false,
      insurance: false,
      non_hometown_halt: false,
      doc: false,
      detentionCustomer: false,
      detentionPlant: false,
      green_tax: false,
      odc_charges: false,
      rto_fines: false
    };

    this.invoiceSequence = {
      custom_IINC_enabled: true,
      custom_range: {
        from: 0,
        to: 0
      },
      custom_text: ''
    };

    this.invoiceSequenceDefault = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      SIN_Code: '',
      counter: 0,
      version_alphabet: 'A',
      series: ''
    };

    this.billSequence = {
      custom_CBIN_enabled: true,
      custom_range: {
        from: 0,
        to: 0
      },
      custom_text: ''
    };

    this.lrSeq = {
      lr_seq: '',
      custom_CWB_enabled: false
    };

    this.billSequenceDefault = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      SIN_Code: '',
      counter: 0,
      version_alphabet: 'A',
      series: ''
    };
    this.paymentInfo = {
      bank_details: {
        account_number: '',
        branch_code: '',
        branch_name: '',
        iba_code: '',
        name: ''
      },
      tax_details: {
        GSTIN: '',
        PAN: '',
        tax_id_3: ''
      },
      URD: false
    };

    this.sac_code = '';
    this.bill_defaultTc = '';
    this.invoice_defaultTc = '';
    this.billing_emails = [];
  }
  getConstants() {
    this.showLoader = true;
    this.http.get('constants').subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          const constants = data.data;

          this.sac_code = constants.sac_code ? constants.sac_code : '';
          // invoice settings
          this.invoiceSequence.custom_IINC_enabled = constants.invoice.custom_IINC_enabled;
          if (this.invoiceSequence.custom_IINC_enabled) {
            this.invoiceSequence.custom_range.from = (constants.invoice && constants.invoice.custom_range && constants.invoice.custom_range.from) ? constants.invoice.custom_range.from : '';
            this.invoiceSequence.custom_range.to = (constants.invoice && constants.invoice.custom_range && constants.invoice.custom_range.to) ? constants.invoice.custom_range.to : '';
            this.invoiceSequence.custom_text = constants.invoice.custom_text;
          } else {
            this.invoiceSequenceDefault.SIN_Code = constants.SIN_code;
            this.invoiceSequenceDefault.counter = constants.invoice.seq;
            this.invoiceSequenceDefault.series = this.invoiceSequenceDefault.year + '/' + this.invoiceSequenceDefault.month + '/' + this.invoiceSequenceDefault.SIN_Code + '/CI/' + this.invoiceSequenceDefault.counter + '/A';
          }

          // bill settings
          this.billSequence.custom_CBIN_enabled = constants.billing.custom_CBIN_enabled;
          if (this.billSequence.custom_CBIN_enabled) {
            this.billSequence.custom_range.to = (constants.billing && constants.billing.custom_range && constants.billing.custom_range.to) ? constants.billing.custom_range.to : '';
            this.billSequence.custom_range.from = (constants.billing && constants.billing.custom_range && constants.billing.custom_range.from) ? constants.billing.custom_range.from : '';
            this.billSequence.custom_text = constants.billing ? constants.billing.custom_text : '';
          } else {
            this.billSequenceDefault.SIN_Code = constants.SIN_code;
            this.billSequenceDefault.counter = constants.billing.seq;
            this.billSequenceDefault.series = this.billSequenceDefault.year + '/' + this.billSequenceDefault.month + '/' + this.billSequenceDefault.SIN_Code + '/CB/' + this.billSequenceDefault.counter + '/A';
          }

          // additonal charges fields
          // this.additionalCharges.extra_pickup = constants.invoice.additional_charges_enabled.extra_pickup;
          // this.additionalCharges.LR_charges = constants.invoice.additional_charges_enabled.LR_charges;
          // this.additionalCharges.insurance = constants.invoice.additional_charges_enabled.insurance;
          // this.additionalCharges.non_hometown_halt = constants.invoice.additional_charges_enabled.non_hometown_halt;
          // this.additionalCharges.toll = constants.invoice.additional_charges_enabled.toll;
          // this.additionalCharges.labour = constants.invoice.additional_charges_enabled.labour;
          // this.additionalCharges.extra_delivery = constants.invoice.additional_charges_enabled.extra_delivery;
          // this.additionalCharges.cancellation = constants.invoice.additional_charges_enabled.cancellation;
          // this.additionalCharges.doc = constants.invoice.additional_charges_enabled.doc;
          // this.additionalCharges.detention = constants.invoice.additional_charges_enabled.detention;

          // bank details and GST details
          if (constants.payment) {
            this.paymentInfo.tax_details.GSTIN = constants.payment.tax_details ? constants.payment.tax_details.GSTIN : '';
            this.paymentInfo.tax_details.PAN = constants.payment.tax_details ? constants.payment.tax_details.PAN : '';
            this.paymentInfo.tax_details.tax_id_3 = constants.payment.tax_details ? constants.payment.tax_details.tax_id_3 : '';
            this.paymentInfo.bank_details.account_number = constants.payment.bank_details ? constants.payment.bank_details.account_number : '';
            this.paymentInfo.bank_details.branch_code = constants.payment.bank_details ? constants.payment.bank_details.branch_code : '';
            this.paymentInfo.bank_details.branch_name = constants.payment.bank_details ? constants.payment.bank_details.branch_name : '';
            this.paymentInfo.bank_details.name = constants.payment.bank_details ? constants.payment.bank_details.name : '';
            this.paymentInfo.bank_details.iba_code = constants.payment.bank_details ? constants.payment.bank_details.iba_code : '';
            this.tempGSTIN = {
              GSTIN: this.paymentInfo.tax_details.GSTIN,
              transporter: this.paymentInfo.tax_details.tax_id_3
            };
            this.paymentInfo.URD = constants.URD || false;
            // this.urdChanges(this.paymentInfo.URD);
          }

          // tax type
          if (!this.paymentInfo.tax_details.GSTIN) {
            this.selectTaxType(this.tax_types[1]);
            this.disable_tax_type = true;
          } else {
            this.selectedTaxType = this.tax_types.filter((option) => {
              return constants.tax_type == option.value;
            })[0];
            this.disable_tax_type = false;

          }
          this. invoiceDeclaration =constants.invoice_declaration;
          // billing emails
          this.billing_emails = constants.billing.email_ids.length ? constants.billing.email_ids.toString() : '';

          // billing default terms and conditions
          this.bill_defaultTc = constants.billing.default_tc || '';

          // invoice default terms and conditions
          this.invoice_defaultTc = constants.invoice.default_tc || '';

          // billing_address
          this.billing_address = constants.billing_address ? constants.billing_address : '';

          // credit note narration
          (constants.narration && constants.narration.credit_note) ? this.creditNoteNarration = constants.narration.credit_note : '';
          (constants.signature) ? this.logo = constants.signature : '';
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  urdChanges(ev) {
    if (ev) {
      this.tempGSTIN = {
        GSTIN: this.paymentInfo.tax_details.GSTIN,
        transporter: this.paymentInfo.tax_details.tax_id_3
      };
      this.paymentInfo.tax_details.tax_id_3 = '';
      this.paymentInfo.tax_details.GSTIN = '';
      this.tempGSTIN.disabled = true;
    } else {
      this.paymentInfo.tax_details.tax_id_3 = this.tempGSTIN.tax_id_3;
      this.paymentInfo.tax_details.GSTIN = this.tempGSTIN.GSTIN;
      this.tempGSTIN.disabled = false;
    }
  }

  // update service code for KSA
  updateSACCOde() {
    const payload = {
      sac_code: this.sac_code
    };
    this.showLoader = true;
    this.http.put('constants/sac_code', payload).subscribe(
      (data: any) => {
        this.showLoader = false;

        if (data.statusCode === 200) {
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.sac_code'), '');
          this.getConstants();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  additionalChargesSettings() {
    this.showLoader = true;
    this.http.put('constants/additional_charges', this.additionalCharges).subscribe(
      (data: any) => {
        this.showLoader = false;

        if (data.statusCode === 200) {
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.additionalCharges'), '');
          this.getConstants();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  updateInvoiceSeq() {
    this.showLoader = true;
    this.invoiceSequence.custom_IINC_enabled = true;
    this.http.put('constants/custom_invoice_seq', this.invoiceSequence).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.invoiceSeq'), '');
          this.getConstants();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  selectTaxType(tax_type) {
    console.log('here', tax_type);
    this.selectedTaxType = tax_type;
  }

  updateTaxType() {
    this.showLoader = true;
    this.http.put('constants/tax_type', { tax_type: this.selectedTaxType.value }).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.tax_type'), '');
          this.getConstants();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  updateBillingEmails() {
    this.showLoader = true;

    if (!this.billing_emails) {
      this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.billing_email_empty'), '', 'err');
      this.showLoader = false;
      return;
    }
    let bill_emailids = this.billing_emails.split(',');
    let valid = true;
    for (let i = 0; i < bill_emailids.length; i++) {
      if (!this.valid.isEmail(bill_emailids[i])) {
        valid = false;
        break;
      }
    }
    if (valid) {
      const data = {
        billMailIds: bill_emailids
      };
      this.http.put('constants/billing_mails', data).subscribe(
        (data: any) => {
          this.showLoader = false;
          if (data.statusCode === 200) {
            this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.billing_email'), '');
            this.getConstants();
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackBar.openSnackBar(err.error.message, '', 'err');
        }
      );
    } else {
      this.showLoader = false;
      this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.invalid_billing_email'), '', 'err');
    }
  }

  updateBillTermsAndConditions() {
    this.showLoader = true;
    const payload = {
      default_tc: this.bill_defaultTc
    };
    this.http.put('constants/bill_terms_conditions', payload).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.terms_conditions'), '');
          this.getConstants();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  updateInvoiceTermsAndConditions() {
    this.showLoader = true;
    const payload = {
      default_tc: this.invoice_defaultTc
    };
    this.http.put('constants/invoice_terms_conditions', payload).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.terms_conditions'), '');
          this.getConstants();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  updateBillSeq() {
    this.showLoader = true;
    this.billSequence.custom_CBIN_enabled = true;
    this.http.put('constants/custom_bill_seq', this.billSequence).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.billSeq'), '');
          this.getConstants();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  updatePaymentInfo() {
    if (this.validateBankDetails()) {
      if (this.country == 'IN' && !this.paymentInfo.tax_details.GSTIN && !this.paymentInfo.tax_details.tax_id_3 && !this.paymentInfo.URD) {
        this.showLoader = false;
        this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.GSTIN_TAXID'), '', 'err');
        return;
      }

      if (!this.paymentInfo.tax_details.GSTIN) {
        delete this.paymentInfo.tax_details.GSTIN;
      }
      if (!this.paymentInfo.tax_details.PAN) {
        delete this.paymentInfo.tax_details.PAN;
      }
      if (!this.paymentInfo.tax_details.tax_id_3) {
        delete this.paymentInfo.tax_details.tax_id_3;
      }
      if (!this.paymentInfo.bank_details.account_number) {
        delete this.paymentInfo.bank_details.account_number;
      }
      if (!this.paymentInfo.bank_details.branch_code) {
        delete this.paymentInfo.bank_details.branch_code;
      }
      if (!this.paymentInfo.bank_details.branch_name) {
        delete this.paymentInfo.bank_details.branch_name;
      }
      if (!this.paymentInfo.bank_details.name) {
        delete this.paymentInfo.bank_details.name;
      }
      if (!this.paymentInfo.bank_details.iba_code) {
        delete this.paymentInfo.bank_details.iba_code;
      }

      this.showLoader = true;
      this.http.put('constants/payment_info', this.paymentInfo).subscribe(
        (data: any) => {
          this.showLoader = false;
          if (data.statusCode === 200) {
            this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.bankDetails'), '');
            this.getConstants();
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackBar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }
  validateBankDetails() {
    // if (this.paymentInfo.tax_details.GSTIN && !this.valid.isGst(this.paymentInfo.tax_details.GSTIN)) {
    //   this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.validGst'), '', 'err');
    //   return false;
    // } else 
    if (this.paymentInfo.tax_details.tax_id_3 && !this.valid.isGst(this.paymentInfo.tax_details.tax_id_3)) {
      this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.validTransporterid'), '', 'err');
      return false;
    } else if (this.paymentInfo.tax_details.PAN && !this.valid.isPan(this.paymentInfo.tax_details.PAN)) {
      this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.validPan'), '', 'err');
      return false;
    }
    return true;
  }

  updatecreditNoteNarration() {
    this.showLoader = true;
    const payload = {
      credit_note_narration: this.creditNoteNarration
    };
    this.http.put('constants/credit_note_narration', payload).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.creditNoteNarration'), '');
          this.getConstants();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  getShippers() {
    this.http.get('shippers').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.shippers = data.data;
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  getCharges(event, org) {
    this.showLoader = true;
    if (event.source._selected) {
      this.selectedOrg = org;
      this.http.get('constants/custom_additional_charges?shipper=' + org._id).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            if (data.data && data.data.additional_charges) {
              this.post = false;
              this.GTAToGTA = data.data.GTAtoGTA;
              const charges = data.data.additional_charges;
              this.additionalCharges = charges;
              this.additionalCharges.charges_id = data.data._id;
            } else {
              this.post = true;
              this.additionalCharges = {
                cancellation: false,
                extra_delivery: false,
                extra_pickup: false,
                labour: false,
                toll: false,
                LR_charges: false,
                insurance: false,
                non_hometown_halt: false,
                doc: false,
                detentionCustomer: false,
                detentionPlant: false,
                green_tax: false,
                odc_charges: false,
                rto_fines: false,
              };
            }
            this.showLoader = false;
          }
        },
        (err: any) => {
          this.snackBar.openSnackBar(err.error.message, '', 'err');
          this.showLoader = false;

        }
      );
    }


  }
  getNewCharges(org) {
    this.showLoader = true;

    this.selectedOrg = org;
    this.http.get('constants/custom_additional_charges?shipper=' + org._id).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          if (data.data && data.data.additional_charges) {
            this.post = false;
            const charges = data.data.additional_charges;
            this.additionalCharges = charges;
            this.additionalCharges.charges_id = data.data._id;
          } else {
            this.post = true;
            this.additionalCharges = {
              cancellation: false,
              extra_delivery: false,
              extra_pickup: false,
              labour: false,
              toll: false,
              LR_charges: false,
              insurance: false,
              non_hometown_halt: false,
              doc: false,
              detentionCustomer: false,
              detentionPlant: false,
              green_tax: false,
              odc_charges: false,
              rto_fines: false,
            };
          }
          this.showLoader = false;

        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
        this.showLoader = false;
      }
    );



  }
  updateCharges() {
    this.showLoader = true;

    const payload: any = {
      shipper: this.selectedOrg._id,
      additional_charges: this.additionalCharges,
      GTAtoGTA: this.GTAToGTA
    };
    if (this.post) {
      delete payload.additional_charges.charges_id;
      this.http.post('constants/custom_additional_charges', payload).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackBar.openSnackBar('Additional charges changes', '');
            this.showLoader = false;

          }
        },
        (err: any) => {
          this.snackBar.openSnackBar(err.error.message, '', 'err');
          this.showLoader = false;
        }
      );
    } else {
      payload.charges_id = this.additionalCharges.charges_id;
      delete payload.additional_charges.charges_id;
      delete payload.additional_charges.detention;
      console.log(' >> ', payload)
      this.http.put('constants/custom_additional_charges', payload).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackBar.openSnackBar('Additional charges changes', '');
            this.getNewCharges(this.selectedOrg);
            this.showLoader = false;
          }
        },
        (err: any) => {
          this.snackBar.openSnackBar(err.error.message, '', 'err');
          this.showLoader = false;
        }
      );
    }
  }
  updateBillingAddress() {
    const payload = {
      billing_address: this.billing_address
    };
    if (this.billing_address) {
      this.showLoader = true;
      this.http.post('settings/billing_address', payload).subscribe(
        (data: any) => {
          this.showLoader = false;
          if (data.statusCode === 200) {
            this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.billing_address'), '');
            this.getConstants();
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackBar.openSnackBar(err.error.message, '', 'err');
        }
      );
    } else {
      this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.BILLING_ADDRESS'), '', 'err');
    }

  }
  fileChanged(event: any) {
    if (event.target.files.length) {
      const formData: any = new FormData();
      formData.append('logo', event.target.files[0], event.target.files[0].name);
      this.showLoader = true;
      this.http.upload('constants/signature', formData).subscribe(
        (response: any) => {
          this.showLoader = false;
          if (response.statusCode == 200) {
            this.snackBar.openSnackBar('Signature updated successfully');
            this.getConstants();
          } else {
            this.snackBar.openSnackBar('Something went wrong. Please try again later','','err');
          }
        },
        (err)=>{
          this.showLoader = false;
          this.snackBar.openSnackBar(err.error.message,'','err');
        }
      );
    }
  }
  onToggle(event) {
    const payload: any = {
      invoice_declaration: this.invoiceDeclaration,
    };
    this.showLoader = true;
    this.http.put('constants/declaration', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.getConstants();
          this.snackBar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.E_invoicing_declaration'), '');
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }
}
